import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { SkillRequest } from 'src/app/models/requests/skill-request';
import { SkillsService } from 'src/app/services/skills.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-skill',
  templateUrl: './new-skill.component.html',
  styleUrls: ['./new-skill.component.css']
})
export class NewSkillComponent {

  name: string = '';
  description: string = '';


  constructor(private skillService: SkillsService, private notification: NotificationService) { }

  
  onSubmit(): void {
    let SkillVm: SkillRequest = {
      name: this.name,
      description: this.description,
    };

    this.skillService.saveSkill(SkillVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Skill Created successfully ${data}`);
          this.description = '';
          this.name = ''

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
